var AbstractDialog = require("common/AbstractDialog");
var Utils = require("common/Utils");

function RenameDialog() {
    AbstractDialog.call(this);

    var self = this;

    var targetPath;
    var origName;

    var $content = this.getContent();
    $content.attr("id", "renameDialog")
        .append($(require("html!./rename_dialog_content.html")));

    var nameInput = $content.find("input");
    var renameButton = $content.find("#renameButton");
    var errorLabel = $content.find("span.errorMessage");

    this.setTitle($.t("common::vfs.renameFileFolder.title"));

    nameInput.on("focus", function() {
        this.setSelectionRange(0, $(this).val().length);
    });

    this.setPath = function(path) {
        var lastSlash = path.lastIndexOf("/");

        targetPath = path.substring(0, lastSlash + 1);
        origName = path.substring(lastSlash + 1);
        nameInput.val(origName);
    };

    function submit() {
        errorLabel.hide();

        self.publishEvent("VFSController", "rename-file-folder", {
            path : targetPath,
            oldName : origName,
            newName : nameInput.val()
        });
    }

    Utils.registerKeyboardSubmit(nameInput, submit);
    renameButton.on("click", submit);

    this.show = function() {
        errorLabel.text("");
        errorLabel.hide();
        this.setEnabled(true);

        nameInput.trigger("focus");
    };

    this.setErrorMessage = function(message) {
        errorLabel.text(message);
        errorLabel.show();
    };

    this.setEnabled = function(val) {
        Utils.setElementEnabled(renameButton, val);
        Utils.setElementEnabled(nameInput, val);
        Utils.setElementEnabled($content.find("a.ui-icon-mobile-close"), val);
    };
}

Utils.inherits(RenameDialog, AbstractDialog);

module.exports = RenameDialog;